import React from 'react';
import { Col } from 'reactstrap';
import language from '../../../assets/languages/language';
import App_data from '../../config/App_data';
import CardImageAndCount from './CardImageAndCount';

function ChapterCard(props) {
  const {
    headerImage,
    chapterOrder,
    chapterNumber,
    chapterName,
    totalReadings,
    headerImageWidth,
    totalNotes,
    premiumQuestionsCount,
    freeQuestionsCount,
    // showFreePremiumTag = true,
    callingComponent,
    children,
    onClick,
    userSubscriptionDetails,
    free,
  } = props;
  return (
    <Col
      xs='12'
      sm={6}
      lg={6}
      xl={4}
      className='question_box free-premium-section'
      key={chapterNumber}
    >
      <div className='question_bank_wrap pointer_class' key={chapterNumber} onClick={onClick}>
        {!Object.keys(userSubscriptionDetails).length && callingComponent === 'notes' ? (
          free ? (
            <div className='tag-tile free'> {language.LC().FREE} </div>
          ) : (
            <div className='tag-tile premium'> {language.LC().PREMIUM} </div>
          )
        ) : null}
        <div className='margin_bottom_30'>
          <img
            src={App_data.frontend_url + headerImage}
            className=''
            width={headerImageWidth || 40}
            alt=''
          />
        </div>
        <div className='question_title' key={chapterNumber} value={chapterNumber}>
          <a>
            {chapterOrder || chapterNumber}. {chapterName}
          </a>
        </div>
        <ul key={chapterName}>
          {/* ============== Total Readings ============== */}
          {totalReadings && (
            <CardImageAndCount
              imageURL='/img/notes/notes_icon2.svg'
              count={totalReadings}
              text={language.LC().TOTAL_READINGS}
              width='24'
            />
          )}

          {/* ============== Total Notes ============== */}
          {totalNotes && (
            <CardImageAndCount
              imageURL='/img/notes/notes_icon3.svg'
              count={totalNotes}
              text={language.LC().TOTAL_NOTES}
              width='20'
            />
          )}

          {/* ============== Free Questions Count============== */}
          {freeQuestionsCount !== 'undefined' && callingComponent !== 'notes' && (
            <CardImageAndCount
              imageURL='/img/question_bank/free_question_icon.svg'
              count={freeQuestionsCount}
              text={language.LC().FREE_QUESTIONS}
              width='26'
            />
          )}

          {/* ============== Premium Questions Count============== */}
          {premiumQuestionsCount && callingComponent !== 'notes' && (
            <CardImageAndCount
              imageURL='/img/question_bank/premium_question_icon.svg'
              count={premiumQuestionsCount}
              text={language.LC().PREMIUM_QUESTIONS}
              width='23'
            />
          )}

          {/* ============== Ready for Print ============== */}
          {callingComponent === 'notes' && (
            <CardImageAndCount
              imageURL='/img/mockexams/print_icon.svg'
              count={language.LC().VIEW}
              text={language.LC().VIEW_PDF}
              width='23'
            />
          )}

          {children}
        </ul>
      </div>
    </Col>
  );
}

export default ChapterCard;



// WEBPACK FOOTER //
// ./src/views/ESG/Chapter/ChapterCard.jsx